import { render, staticRenderFns } from "./myTasks.vue?vue&type=template&id=32dc8a50&scoped=true&"
import script from "./myTasks.vue?vue&type=script&lang=js&"
export * from "./myTasks.vue?vue&type=script&lang=js&"
import style0 from "./myTasks.vue?vue&type=style&index=0&id=32dc8a50&scoped=true&lang=css&"
import style1 from "./myTasks.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dc8a50",
  null
  
)

export default component.exports